((window, document) => {
  function initiateTilePricing() {
    const tiles = document.querySelectorAll('.monthly-price');
    tiles.forEach((tile) => {
      const price = parseInt(tile.innerHTML.slice(1), 10);
      const resultTileBody = tile.closest('.result-tile__body');
      if (price < 2 || Number.isNaN(price)) {
        const callUs = document.createElement('div');
        callUs.classList.add(
          'font--bold',
          'text--red',
          'text-align--center',
          'heading--3',
          'padding-top-40',
          'padding-bottom-30',
        );
        callUs.innerHTML =
          "<svg class='icon primary-nav__phone' style='vertical-align: bottom;'><use xlink:href='#primaryNavPhone'></use></svg> Call for price";
        resultTileBody.innerHTML = '';
        resultTileBody.appendChild(callUs);
      }
    });
    const hpTiles = document.querySelectorAll('.monthly-hp-price');
    hpTiles.forEach((tile) => {
      const hpPrice = parseInt(tile.innerHTML.slice(1), 10);
      const hpResultTileBody = tile.closest('.result-tile__body');
      if (hpPrice < 2 || Number.isNaN(hpPrice)) {
        hpResultTileBody.querySelector('.no-hp-price').classList.remove('hide__default');
        hpResultTileBody.querySelector('.hp-price').classList.add('hide__default');
      }
    });
  }

  function initiateRadios() {
    const radios = document.querySelectorAll('input[name^="buyLeaseView-"]');
    radios.forEach((radio) => {
      radio.addEventListener('change', (e) => {
        const tile = e.target.closest('.grid-tile');
        tile.querySelector('.lease-content').classList.toggle('hide__default');
        tile.querySelector('.buy-content').classList.toggle('hide__default');
        const financeType = e.target.id.includes('buy') ? 'buy' : 'lease';
        const requestQuoteButton = tile.querySelector('.js-request-quote');
        const viewOfferCtas = tile.querySelectorAll('.js-viewoffer');
        const oldHref = requestQuoteButton.getAttribute('href');
        const newHref = `${oldHref.slice(0, oldHref.indexOf('?finType='))}?finType=${financeType}`;
        requestQuoteButton.setAttribute('href', newHref);
        viewOfferCtas.forEach((cta) => {
          cta.classList.remove('dt-lease-viewoffer', 'dt-buy-viewoffer');
          const newClass = `dt-${financeType}-viewoffer`;
          cta.classList.add(newClass);
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initiateTilePricing();
    initiateRadios();
  });
})(window, document);
